import { render, staticRenderFns } from "./MarriageReportOne.vue?vue&type=template&id=74b98b52&"
import script from "./MarriageReportOne.vue?vue&type=script&lang=js&"
export * from "./MarriageReportOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports